/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Stack, Box, Button, HStack} from '@salesforce/retail-react-app/app/components/shared/ui'
import Field from '../../components/field'
import useLoginFields from '../../components/forms/useLoginFields'

const LoginFields = ({
    form,
    handleForgotPasswordClick,
    prefix = '',
    hideEmail = false,
    hidePassword = false,
    rememberme = false,
    isLoginPage = false
}) => {
    const fields = useLoginFields({form, prefix})
    return (
        <Stack spacing={2}>
            {!hideEmail && <Field {...fields.email} isLoginPage={isLoginPage} />}
            {!hidePassword && (
                <>
                    <Field {...fields.password} isLoginPage={isLoginPage} />
                    <HStack justifyContent="space-between" alignItems="center">
                        {!rememberme && (
                            <Field
                                {...fields.rememberme}
                                isLoginPage={isLoginPage}
                                labelProps={{fontSize: 'xs'}}
                                inputProps={{
                                    mt: '3px',
                                    sx: {
                                        '.chakra-checkbox__control': {
                                            mt: '3px'
                                        }
                                    }
                                }}
                            />
                        )}
                        {handleForgotPasswordClick && (
                            <Box textAlign="right">
                                <Button
                                    variant="link"
                                    onClick={handleForgotPasswordClick}
                                    fontSize="xs"
                                    textDecoration="underline"
                                >
                                    <FormattedMessage
                                        defaultMessage="Forgot password?"
                                        id="contact_info.link.forgot_password"
                                    />
                                </Button>
                            </Box>
                        )}
                    </HStack>
                </>
            )}
        </Stack>
    )
}

LoginFields.propTypes = {
    handleForgotPasswordClick: PropTypes.func,

    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string,

    /** Optional configurations */
    hideEmail: PropTypes.bool,
    hidePassword: PropTypes.bool,
    rememberme: PropTypes.bool,
    isLoginPage: PropTypes.bool
}

export default LoginFields
